var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center w-full bg-white p-3 hlg:p-4 text-lighPurple border-b",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"flex-grow"},[_vm._v(_vm._s(_vm.text))]),_c('ChevronRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }